import React from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { PositionStyleEnum } from '../../../../../../../types';

import { useCurrentUser } from '../../../../../../../auth/hooks/useAuth';
import { useDropdownState } from '../../../../../../../helpers/dropdowns/hooks/useDropdownState';

import { Translate } from '../../../../../../../helpers/Translate';
import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Popover } from '../../../../../../../helpers/Popover';
import { Icon } from '../../../../../../../helpers/Icon';

import { PopoverPlacement } from '../../../../../../../helpers/Popover/popoverConstants';

import { StockPermissions } from '../../../../../stockConstants';

import { words } from '../../../../../../../locales/keys';

const dropdownOffset = 0;

interface ThreeDStockHeaderAddButtonProps {
  isLib: boolean;
  libHref?: string;
  stockHref?: string;
}

function ThreeDStockHeaderTitleButton({
  isLib,
  libHref,
  stockHref
}: ThreeDStockHeaderAddButtonProps) {
  const currentUser = useCurrentUser();

  const {
    isPopoverOpen,
    referencePopoverElement,
    referencePopoverCallbackRef,
    togglePopover,
    closePopover
  } = useDropdownState();

  const withStockMenu = currentUser.hasPermissions(
    StockPermissions.READ_THREE_D_STOCK_HEADER_MENU
  );

  const withoutLinks = !libHref || !stockHref;

  return (
    <div className="hidden lg:flex items-center gap-0.5">
      {(!withStockMenu || withoutLinks) && (
        <div className="hidden lg:flex items-center gap-0.5">
          <span className="text-lg font-bold px-4">
            <Translate id={isLib ? words.myLibrary : words.threeDStock} />
          </span>
        </div>
      )}

      {withStockMenu && !withoutLinks && (
        <div
          className="relative hidden md:flex items-center justify-center"
          ref={referencePopoverCallbackRef}
          onMouseEnter={togglePopover}
          onMouseLeave={togglePopover}
        >
          <NextLinkHelper
            className="flex items-center text-lg font-bold px-2 py-2 rounded-md group-hover:rounded-b-none hover:bg-gray-100 dark:hover:bg-gray-850"
            href={isLib ? libHref : stockHref}
            dataGa={isLib ? 'library-link' : 'stock-link'}
          >
            <span className="px-2">
              <Translate id={isLib ? words.myLibrary : words.threeDStock} />
            </span>

            <Icon
              icon={IconsEnum.ARROW_DOWN_TRIANGLE_SOLID}
              className="h-5 w-5"
            />
          </NextLinkHelper>

          {isPopoverOpen ? (
            <Popover
              className="rounded-md bg-gray-50 dark:bg-gray-800 border dark:border-gray-700 shadow-xl z-50"
              closePopover={closePopover}
              distanceOffset={dropdownOffset}
              positionStyle={PositionStyleEnum.fixed}
              placement={PopoverPlacement.BOTTOM_END}
              referenceElement={referencePopoverElement}
              closeOnOuterClick
            >
              <NextLinkHelper
                className="flex items-center text-lg font-bold px-2 py-2 rounded-md group-hover:rounded-b-none hover:bg-gray-100 dark:hover:bg-gray-850"
                href={isLib ? stockHref : libHref}
                dataGa={isLib ? 'stock-link' : 'library-link'}
              >
                <span className="px-2">
                  <Translate id={isLib ? words.threeDStock : words.myLibrary} />
                </span>
              </NextLinkHelper>
            </Popover>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default ThreeDStockHeaderTitleButton;
